<script>
import CandelaControl from '@/components/controls/CandelaControl'

export default {
  extends: CandelaControl,
  name: 'candela-button-group',
  props: {
    items: {type: Array, default: () => []},
    mandatory: {type: Boolean, default: () => false},
    multiple: {type: Boolean, default: () => false}
  }
}
</script>

<template>
<div v-if='label' class='d-flex flex-column flex-grow-1 align-stretch'>
  <div>
    <div class='d-flex flex-grow-1 justify-cetner
      overline font-weight-bold primary--text mb-2 mt-1 ml-1'>{{label}}</div>
    <v-btn-toggle v-model='value' :mandatory='mandatory'
      :multiple='multiple' class='d-flex flex-grow-0 align-center' >
      <v-btn v-for='(btn, i) in items' :key='i' class='flex-grow-1'>
        <candela-icon v-if='btn.icon' :name='btn.icon'
          :icon_props='{left:btn.label === "", small: true}' class='mr-2'/>
        <span v-if='btn.label'>{{btn.label}}</span>
      </v-btn>
    </v-btn-toggle>
  </div>
</div>
</template>

<style lang='sass' scoped>
.v-btn-toggle
  flex-wrap: wrap !important
</style>
